import _toConsumableArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';

var appendScript = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(src) {
    var tag;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!document.querySelectorAll("script[src=\"".concat(src, "\"]")).length) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            tag = document.createElement('script');
            tag.src = src;
            tag.async = true;
            document.body.appendChild(tag);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function appendScript(_x) {
    return _ref.apply(this, arguments);
  };
}();

// Initialize custom event for wistia
if (true) {
  window['_wq'] = window['_wq'] || [];
  window['_wq'].push({
    id: '_all',
    onReady: function onReady() {
      document.dispatchEvent(new Event('wistia_loaded'));
    }
  });
}

var classnames = {
  thumbnail: 'wistia_thumbnail',
  responsiveWrapper: 'wistia_responsive_wrapper',
  deferred: 'wistia_deferred',
  embed: 'wistia_embed',
  swatch: 'wistia_swatch',
  background: 'background',
  async: function async(id) {
    return "wistia_async_".concat(id);
  }
};
var wistiaFlags = {
  noSEO: 'seo=false',
  videoFoam: 'videoFoam=true',
  autoPlay: 'autoPlay=true'
}; // Hook to initialize the listeners/setup on wistia (managing classes to display the video), use useEffect to avoid SSR issues

var useWistia = function useWistia(videoId) {
  var addThumbnailsListeners = function addThumbnailsListeners() {
    var thumbnails = [].slice.call(document.getElementsByClassName(classnames.thumbnail));

    var _iterator = _createForOfIteratorHelper(thumbnails),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var thumbnail = _step.value;

        if (!thumbnail.dataset.hasListeners) {
          thumbnail.dataset.hasListeners = 'true';
          thumbnail.addEventListener('click', handleThumbnailClick);
          thumbnail.addEventListener('keypress', handleThumbnailKeyPress);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var handleThumbnailKeyPress = function handleThumbnailKeyPress(event) {
    event.preventDefault();

    if (event.key === ' ' || event.key === 'Enter') {
      handleThumbnailClick(event);
    }
  };

  var handleThumbnailClick = function handleThumbnailClick(event) {
    var _thumbnail$parentNode;

    var thumbnail = event.target;
    var wrapper = (_thumbnail$parentNode = thumbnail.parentNode) === null || _thumbnail$parentNode === void 0 ? void 0 : _thumbnail$parentNode.parentNode;

    if (!wrapper) {
      return;
    }

    var deferred = wrapper.querySelector(".".concat(classnames.deferred));

    if (deferred) {
      deferred.classList.add(classnames.responsiveWrapper);
      wrapper.style.minHeight = "".concat(thumbnail.offsetHeight, "px");
      thumbnail.classList.add(classnames.background);
      initWistiaVideo({
        wrapper: deferred
      });
    }
  };

  var initializeWrappers = function initializeWrappers() {
    var wrappers = [].slice.call(document.getElementsByClassName(classnames.responsiveWrapper));

    if (wrappers.length === 0) {
      return;
    }

    var _iterator2 = _createForOfIteratorHelper(wrappers),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var wrapper = _step2.value;
        initWistiaVideo({
          wrapper: wrapper
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };

  useEffect(function () {
    if (videoId) {
      addThumbnailsListeners();
      initializeWrappers();
    }
  });
};

var initWistiaVideo = function initWistiaVideo(_ref2) {
  var wrapper = _ref2.wrapper,
      _ref2$embedId = _ref2.embedId,
      embedId = _ref2$embedId === void 0 ? null : _ref2$embedId,
      _ref2$autoPlay = _ref2.autoPlay,
      autoPlay = _ref2$autoPlay === void 0 ? false : _ref2$autoPlay,
      _ref2$videoId = _ref2.videoId,
      videoId = _ref2$videoId === void 0 ? null : _ref2$videoId,
      _ref2$classes = _ref2.classes,
      classes = _ref2$classes === void 0 ? [] : _ref2$classes;

  if (!wrapper || wrapper.dataset.wistiaPrepared) {
    return;
  }

  var wistiaId = wrapper.dataset.wistiaVideoId || videoId;

  if (wistiaId) {
    var _embed$classList;

    appendWistiaScript();
    wrapper.dataset.wistiaPrepared = 'true';
    var wrapperIsDeferred = wrapper.classList.contains(classnames.deferred);
    var embedClasses = [classnames.embed, classnames.async(wistiaId), wistiaFlags.noSEO, wistiaFlags.videoFoam];

    if (classes.length) {
      embedClasses.push.apply(embedClasses, _toConsumableArray(classes));
    }

    if (autoPlay || wrapperIsDeferred) {
      embedClasses.push(wistiaFlags.autoPlay);
    }

    var embed = document.createElement('div');

    (_embed$classList = embed.classList).add.apply(_embed$classList, embedClasses);

    var swatch = document.createElement('div');
    swatch.classList.add(classnames.swatch);
    swatch.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;';
    wrapper.appendChild(embed).appendChild(swatch);
    wrapper.dataset.testid = 'wistia-element-ref';

    if (embedId) {
      embed.id = embedId;
    }
  }
}; // Wistia hook so we can have easy access to "onReady" listener and get the video api


var useWistiaVideoApi = function useWistiaVideoApi(_ref3) {
  var id = _ref3.id,
      jsonp = _ref3.jsonp,
      onReady = _ref3.onReady,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? {} : _ref3$options;

  var _useState = useState(),
      videoApi = _useState[0],
      setVideoApi = _useState[1];

  useEffect(function () {
    window['_wq'] = window['_wq'] || [];
    window['_wq'].push({
      id: id,
      onReady: function onReady(api) {
        setVideoApi(api);

        if (jsonp) {
          appendWistiaJsonpScript(id);
        }

        return api;
      },
      options: options
    });
  }, []);
  return videoApi;
};

var appendWistiaScript = function appendWistiaScript() {
  appendScript('https://fast.wistia.com/assets/external/E-v1.js');
};

var appendWistiaJsonpScript = function appendWistiaJsonpScript(id) {
  appendScript("https://fast.wistia.com/embed/medias/".concat(id, ".jsonp"));
};

export { initWistiaVideo, useWistia, useWistiaVideoApi, appendWistiaScript, appendWistiaJsonpScript };